const stripHtmlTags = (str) =>
  !str ? '' : str.toString().replace(/<[^>]*>/g, ' ')

export default stripHtmlTags
